/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SummaryDTO } from './summary-dto';
import { TipologiaPratica } from './tipologia-pratica';


export interface ServizioListItemDTO { 
    id?: string;
    tipo_servizio?: ServizioListItemDTOTipoServizioEnum;
    tipo_pratica_id?: string;
    tipo_pratica_codice?: string;
    tipo_pratica_titolo?: string;
    tipologia_pratica?: TipologiaPratica;
    comune_id?: string;
    comune_nome?: string;
    data_inizio?: string;
    data_fine?: string;
    summary?: SummaryDTO;
}
export enum ServizioListItemDTOTipoServizioEnum {
    MENSA = 'MENSA'
};



